import React from 'react';
import { CardHcdAvailabilityOutputDTO } from '@maiia/model/generated/model/api-patient/api-patient';
import { NoSsr } from '@mui/material';
import ProCardDescription from '@/components/organisms/ProCard/ProCardDescription';
import ProCardAvailabilitiesCalendar from '@/components/organisms/ProCard/ProCardAvailabilitiesCalendar';
import { useTranslation } from '@/src/i18n';

interface ProCardAvailabilitiesProps {
  item: CardHcdAvailabilityOutputDTO;
  goToHcdPage: (event: React.MouseEvent, slot?: string) => void;
  onClickTimeSlot?: (event: React.MouseEvent) => void;
  onClickCTA?: (event: React.MouseEvent) => void;
}

const ProCardAvailabilities: React.FC<ProCardAvailabilitiesProps> = ({
  item,
  goToHcdPage,
  onClickTimeSlot,
  onClickCTA,
}) => {
  const { t } = useTranslation();

  const { client = false, onlineBookingEnabled = false } = item;

  if (!client)
    return (
      <ProCardDescription>
        {t('pro_card_unavailable_appointments')}
      </ProCardDescription>
    );

  if (!onlineBookingEnabled)
    return (
      <ProCardDescription>
        {t('pro_card_no_online_appointments')}
      </ProCardDescription>
    );

  return (
    <NoSsr>
      <ProCardAvailabilitiesCalendar
        card={item}
        goToHcdPage={goToHcdPage}
        onClickTimeSlot={onClickTimeSlot}
        onClickCTA={onClickCTA}
      />
    </NoSsr>
  );
};

export default React.memo(
  ProCardAvailabilities,
  (oldProps, newProps) => oldProps.item.id === newProps.item.id,
);
